import { PropsWithChildren, useEffect, useContext } from "react";
import { PortalPageContext } from "./PortalPageContext";

export const PortalHeaderActions = ({ children }: PropsWithChildren) => {
  const { setHeaderActions } = useContext(PortalPageContext);

  useEffect(() => {
    setHeaderActions(children);
    return () => setHeaderActions(null);
  }, [children, setHeaderActions]);

  return null;
};
